<script>
import axios from 'axios'
import qs from 'qs'

import CardPage from './CardPage.vue'
import CardPost from './CardPost.vue'
import CardPostProject from './CardPostProject.vue'
import CardPostEvent from '@bahn-wordpress/dbec-events/src/js/components/CardPostEvent.vue'
import { langCode } from '@bahn-wordpress/common/src/js/utils/language'
import eventEmitter from '@bahn-wordpress/common/src/js/utils/event-emitter'
import * as events from '@bahn-wordpress/common/src/js/utils/events'

const POSTS_PER_PAGE = 10

const MAP_CARD_COMPONENT = {
    'page': CardPage,
    'post': CardPost,
    'dbec_project': CardPostProject,
    'dbec_event': CardPostEvent,
}

const MAP_LABEL_TYPE = {
    'page': 'labelPage',
    'post': 'labelNews',
    'dbec_project': 'labelProjects',
}

export default {
    name: 'Search',

    components: {
        // eslint-disable-next-line vue/no-unused-components
        CardPost,
        CardPage,
        CardPostProject,
    },

    props: {
        labelNews: {
            type: String,
            default: '',
        },
        labelProjects: {
            type: String,
            default: '',
        },
        labelPage: {
            type: String,
            default: '',
        },
    },

    data(){
        return {
            results: [],
            totalPages: 0,
            actualPage: 1,
            searchInput: '',
            searchDone: false,
            countResults: null,
            urlSearchParams: null,
            persistentIndex: 0,
            isLoading: false,
            isBooted: false,
            installedPostTypes: [],
        }
    },

    computed: {
        showButtonLoadMore(){
            return this.actualPage < this.totalPages
        },

        searchDisabled(){
            return this.searchInput.length < 2
        },

        noResults(){
            return this.searchDone && this.results.length < 1
        },

        showCountResults(){
            return this.searchDone && this.results.length > 0
        },

        styleResults(){
            const refListPostsResults = this.$refs.containerResults
            const height = (this.isLoading && refListPostsResults) ? `${refListPostsResults.offsetHeight}px` : 'auto'

            return {
                height,
            }
        },
    },

    created(){
        this.readoutUrlParams()
        this.getInstalledPostTypesFromHead()

        if (this.urlSearchParams.has('search')) {
            this.setInputValueFromParams()
            this.loadSearchResults()
        }
    },

    mounted(){
        this.$el.classList.add('search--booted')

        setTimeout(() => {
            this.focusInput()
        }, 100)
    },

    methods: {
        getInstalledPostTypesFromHead(){
            const installedPostTypesString = document.head.querySelector('meta[name="installed-post-types"]')

            if (installedPostTypesString && installedPostTypesString.getAttribute('content')) {
                this.installedPostTypes = installedPostTypesString.getAttribute('content').split(',')
            }
        },
        focusInput(){
            const searchInput = this.$el.querySelector('.search__input')
            console.log('searchInput', searchInput)
            searchInput.focus()
        },
        readoutUrlParams(){
            const searchString = window.location.search
            this.urlSearchParams = new URLSearchParams(searchString)
        },

        onSearchInput(event){
            this.searchInput = event.target.value
        },

        setInputValueFromParams(){
            this.searchInput = this.urlSearchParams.get('search')
        },

        onSubmit(event){
            event.preventDefault()
            console.log('on submit', !this.searchDisabled)

            if (!this.searchDisabled) {
                this.clearResults()
                this.updatePersistentIndex()
                this.updateURLSearchParams()
                this.loadSearchResults()
            }
        },

        clearResults(){
            this.results = []
        },

        updatePersistentIndex(){
            this.persistentIndex += 1
        },

        updateURLSearchParams(){
            this.urlSearchParams.set('search', encodeURI(this.searchInput))

            const queryString = this.urlSearchParams.toString()
            window.history.replaceState(null, null, `?${queryString}`)
        },

        loadSearchResults(replaceOldResults = true){

            this.isLoading = true

            const params = {
                per_page: POSTS_PER_PAGE,
                _embed: '',
                page: this.actualPage,
                search: this.urlSearchParams.get('search'),
                'subtype[]': this.installedPostTypes,
            }

            axios.get(`/${langCode}/wp-json/wp/v2/search`, { params, paramsSerializer: this.paramsSerializer } )
                .then((response) => {
                    console.log(response)

                    const parsedResults = this.parseResults(response.data)

                    this.searchDone = true
                    this.countResults = response.headers['x-wp-total']
                    this.totalPages = response.headers['x-wp-totalpages']
                    this.results = replaceOldResults? parsedResults : [ ...this.results, ...parsedResults]

                    this.isLoading = false

                    this.emitEventItemsLoaded()
                })
                .catch((error) => {
                    console.log(error)
                    this.isLoading = false
                })
        },

        paramsSerializer(params){
            return qs.stringify(params, {arrayFormat: 'repeat', encode: false})
        },

        parseResults(results){
            return results.map(result => {
                const subtype = result.subtype
                const embeddedItem = result._embedded.self[0]
                embeddedItem.type = subtype
                return embeddedItem
            })
        },

        emitEventItemsLoaded(){
            requestAnimationFrame(() => {
                eventEmitter.emit(events.listItemsLoaded)
            })
        },

        getComponentByType(type){
            return MAP_CARD_COMPONENT[type]
        },

        getLabelByType(type){
            const propName = MAP_LABEL_TYPE[type]
            return this[propName]
        },

        onLoadMoreClicked(){
            this.actualPage += 1
            this.loadSearchResults(false)
        },
    },
}
</script>
